<div class="container-fluid">
    <div class="container">
        <div class="row">
            <div class="col-md-5">
                <div class="card">
                    <div class="card-body">
                        <h3 class="card-title">Contacts</h3>
                        <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Offics voluptates officiis sit, cumque velit eius. Iusto cum consequatur quae eum numquam tempora dolorum iste ex, nihil rem. Quis, distinctio! Reprehenderit necessitatibus neque architecto delectus ab vitae velit iure odio!</p>
                        <p class="card-text"><span>Address: </span> Santa Cruz del Quiche, el Quiche</p>
                        <p class="card-text"><span>Phone: </span> +502 48946048</p>
                        <p class="card-text"><span>Email: </span> david@123.com</p>
                        <p class="card-text"><span>Fax: </span> 4 894 60 48</p>
                    </div>
                </div>
            </div>
            <div class="col-md-7 spacing">
                <div class="card">
                    <form action="#">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-6">
                                    <input type="text" class="form-control" placeholder="Your Name">
                                </div>
                                <div class="col-6">
                                    <input type="email" class="form-control" placeholder="Your Email">
                                </div>                       
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">  
                                <div class="col-12">
                                    <input type="text" class="form-control" placeholder="Your Title">
                                </div>                       
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">  
                                <div class="col-12">
                                    <textarea name="description" class="form-control" placeholder="Description"></textarea>
                                </div>                       
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">  
                                <div class="col-6">
                                    <input class="btn btn-dark" type="submit" value="SEND MESSAGE">
                                </div>                       
                            </div>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
</div>